<template>
  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
  <path d="M12 16v-4M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</template>
